export enum Route {
  reports = 'reports',
  editReports = 'edit-reports',
  reportPages = 'report-pages',
  editReportPages = 'edit-report-pages',
  reportPageEditor = 'report-page-editor',
  company = 'company',
  customer = 'customer',
  customers = 'customers',
  categorySettings = 'category-settings',
  notifications = 'notifications',
  paths = 'paths',
  modules = 'modules',
  module = 'module',
  licenses = 'licences',
  documents = 'documents',
  debugInfo = 'debug-info',
  overview = 'overview',
  processedVouchers = 'processed-vouchers',
  processedVouchersDetailed = 'processed-vouchers-detailed',
  unprocessedVoucherFavorite = 'unprocessed-voucher-favorite',
  unprocessedVoucherList = 'unprocessed-voucher-list',
  transactionsOverview = 'transactions-overview',
  categories = 'categories',
  customerSettings = 'customer-settings',
  upvsGrouped = 'upvs-grouped',
  favoriteVouchersGrouped = 'favorite-vouchers-grouped',
  upv = 'upv',
  transactionGlAccounts = 'transaction-gl-accounts',
  externalData = 'external-data',
  permissions = 'permissions',
  rolePermissions = 'role-permissions',
  acceptEula = 'accept-eula',
  customerAgreements = 'customer-agreements',
  eula = 'eula',
  unconverted = 'unconverted',
  glTransactions = 'gl-transactions',
  reconcile = 'reconcile',
  reconcileNew = 'reconcile-new',
  reconcileSummary = 'reconcile-summary',
  activeCompanies = 'active-companies',
  settings = 'settings',
  categoryTypes = 'category-types',
  allVouchers = 'all-vouchers',
  allVouchersGrouped = 'all-vouchers-grouped',
  mandateControl = 'mandate-control',
  corporations = 'corporations',
  taxValues = 'tax-values',
  packages = 'packages',
  licenseOwners = 'license-owners',
  partners = 'partners',
  invoicesList = 'invoices-list',
  invoiceGeneration = 'invoice-generation',
  invoiceReporting = 'invoice-reporting',
  bankAccountSettings = 'bank-account-settings',
  openingPositions = 'opening-positions',
}
